import React from 'react'
import { Typography, Box } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { Batch } from '../../models/batch'
import { calculateLifeStatus } from '../../utils/calculateLifeStatus'

interface BatchReadOnlyDataProps {
	selectedBatch: Batch
}

export const BatchReadOnlyData = (props: BatchReadOnlyDataProps) => {
	const { selectedBatch } = props
	const status = calculateLifeStatus(selectedBatch.date, selectedBatch.expiration)
	const statusColor = {
		success: '#4caf50',
		warning: '#ff9800',
		error: '#f44336'
	}[status]

	const {
		crop,
		category,
		germplasm,
		owner,
		origin,
		date,
		bulk,
		grossweight,
		tare,
		netweight,
		cardNumber,
		humidity,
		plague,
		availableBackup,
		rejectionBackup,
		lossesBackup,
		active,
		notes
	} = selectedBatch

	const calculateAge = (date: string): string => {
		const currentDate = new Date()
		const batchDate = new Date(date)
		const diffTime = Math.abs(currentDate.getTime() - batchDate.getTime())
		const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
		const months = Math.floor(diffDays / 30)
		const days = diffDays % 30
		return `${months} meses y ${days} días`
	}

	return (
		<Box sx={{ position: 'relative' }}>
			<Box
				sx={{
					width: 25,
					height: 25,
					borderRadius: '50%',
					backgroundColor: statusColor,
					position: 'absolute',
					top: 0,
					right: 0,
					zIndex: 1
				}}
			/>
			<Grid container spacing={2} mb={2}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Cultivo:</strong> {crop}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Categoría:</strong> {category}
					</Typography>
				</Grid>
			</Grid>

			<Grid container spacing={2} mb={2}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Germoplasma:</strong> {germplasm}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Propietario:</strong> {owner}
					</Typography>
				</Grid>
			</Grid>

			<Grid container spacing={2} mb={2}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Procedencia:</strong> {origin}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Fecha de Ingreso:</strong> {new Date(date).toLocaleDateString()}
					</Typography>
				</Grid>
			</Grid>

			<Grid container spacing={2} mb={2}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Número de Bultos:</strong> {bulk}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Cantidad Bruta:</strong> {grossweight}
					</Typography>
				</Grid>
			</Grid>

			<Grid container spacing={2} mb={2}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Tara:</strong> {tare}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Cantidad Neta:</strong> {netweight}
					</Typography>
				</Grid>
			</Grid>

			<Grid container spacing={2} mb={2}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>No. Tarjeta:</strong> {cardNumber || 'N/A'}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Humedad:</strong> {humidity}
					</Typography>
				</Grid>
			</Grid>

			<Grid container spacing={2} mb={2}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Plaga:</strong> {plague}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Semillas (Quintales):</strong> {availableBackup}
					</Typography>
				</Grid>
			</Grid>

			<Grid container spacing={2} mb={2}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Rechazo (Quintales):</strong> {rejectionBackup}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Pérdidas (Quintales):</strong> {lossesBackup}
					</Typography>
				</Grid>
			</Grid>

			<Grid container spacing={2} mb={2}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Estado:</strong> {active ? 'Activo' : 'Inactivo'}
					</Typography>
				</Grid>
			</Grid>

			<Grid container spacing={2} mb={2}>
				<Grid size={{ xs: 12 }}>
					<Typography>
						<strong>Notas:</strong> {notes}
					</Typography>
				</Grid>
			</Grid>

			<Grid container spacing={2} mb={2}>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Edad del Lote:</strong> {calculateAge(selectedBatch.date)}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 6 }}>
					<Typography>
						<strong>Caducidad:</strong> {selectedBatch.expiration} meses
					</Typography>
				</Grid>
			</Grid>
		</Box>
	)
}
